export default __webpack_public_path__ + "static/media/coinbase.4825fc96.svg";